import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationGB from "./assets/locales/gb/translation.json";
import translationSI from "./assets/locales/si/translation.json";
import translationRS from "./assets/locales/rs/translation.json";
import translationHU from "./assets/locales/hu/translation.json";

const resources = {
  gb: {
    translation: translationGB
  },
  si: {
    translation: translationSI
  },
  rs: {
    translation: translationRS
  },
  hu: {
    translation: translationHU
  }
};

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'gb',
    debug: true,
    resources: resources,
    interpolation: {
      escapeValue: false
    }
  });


export default i18n;